// 교관 세르의 「전직」 구역 DOM(3개월 C10-5). 값은 jobModel.ts(순수)가 만들고 여기서는 그리기·버튼만 한다.
// 전직 전: 교관 대사 + 관문 3줄(통과 ✓ / 도전 / 잠김 사유) → 관문을 모두 넘으면 갈래 카드 2장 → 「이 갈래로 전직」 → 확인 단계(되돌릴 수 없음) → jobChoose.
// 전직 I: 전직 II 관문 3줄 → 「전직 II 승급」(jobAdvance) → 전직 완료 요약. RpgUi가 값이 바뀔 때만 다시 그린다.
import type { GameCommand, GameView } from '../shared/types';
import { JOB_BRANCHES, JOB_LEVEL, JOB_TRAINER_TITLE, type JobHeroId } from '../shared/content/jobQuest';
import { FONT, el } from './dom';
import { growthOf } from './skillTreeModel';
import { jobPanelModel, type JobGateRow } from './jobModel';

const STYLE_ID = 'dh-job-style';
const CSS =
  '.dh-job{flex:1 1 auto;min-height:0;overflow-y:auto;overscroll-behavior:contain;display:flex;flex-direction:column;gap:10px;padding:10px 12px 14px;font-family:' + FONT + ';color:#eef2ff;scrollbar-width:thin}' +
  '.dh-job-say{padding:10px 12px;border-radius:10px;border:1.5px solid rgba(242,193,78,.45);background:linear-gradient(180deg,rgba(40,34,18,.92),rgba(18,16,12,.92));font:600 14px/1.5 ' + FONT + ';color:#ffe9b8}' +
  '.dh-job-say b{display:block;font:900 12px ' + FONT + ';color:#f2c14e;letter-spacing:.5px;margin-bottom:2px}' +
  '.dh-job-step{font:900 15px ' + FONT + ';color:#f2c14e;display:flex;justify-content:space-between;gap:8px;flex-wrap:wrap}' +
  '.dh-job-step small{font:700 12px ' + FONT + ';color:#aeb9da}' +
  '.dh-job-gate{display:grid;grid-template-columns:minmax(0,1fr) auto;align-items:center;gap:6px 10px;padding:9px 10px;border-radius:10px;border:1.5px solid rgba(120,138,190,.4);background:rgba(10,18,36,.85)}' +
  '.dh-job-gate.open{border-color:rgba(242,193,78,.75);background:linear-gradient(180deg,rgba(40,34,18,.9),rgba(14,16,28,.9))}' +
  '.dh-job-gate.passed{border-color:rgba(63,208,122,.6)}' +
  '.dh-job-gate.locked{opacity:.78}' +
  '.dh-job-gate .nm{font:900 14px/1.35 ' + FONT + ';color:#fff;min-width:0;overflow-wrap:anywhere}' +
  '.dh-job-gate .ht{grid-column:1/2;font:600 12px/1.45 ' + FONT + ';color:#bdcce0;min-width:0;overflow-wrap:anywhere}' +
  '.dh-job-gate .st{grid-column:2/3;grid-row:1/3;align-self:center;justify-self:end;font:900 13px ' + FONT + ';white-space:nowrap;text-align:right}' +
  '.dh-job-gate .st.ok{color:#7dffa0}.dh-job-gate .st.lock{color:#ff9aa4;white-space:normal;max-width:96px}' +
  '.dh-job-gate .dh-r-btn{min-width:72px;padding:6px 14px;font-size:15px}' +
  '.dh-job-cards{display:grid;grid-template-columns:repeat(auto-fit,minmax(140px,1fr));gap:8px}' +
  '.dh-job-card{display:flex;flex-direction:column;gap:6px;min-width:0;padding:10px;border-radius:12px;border:2px solid var(--bc);background:linear-gradient(180deg,color-mix(in srgb,var(--bc) 22%,#0c1226),#0a0f20);box-shadow:inset 0 0 22px color-mix(in srgb,var(--bc) 28%,transparent)}' +
  '.dh-job-card.dim{opacity:.5}' +
  '.dh-job-card h4{margin:0;font:900 17px/1.25 ' + FONT + ';color:#fff;text-shadow:0 0 10px var(--bc);overflow-wrap:anywhere}' +
  '.dh-job-card p{margin:0;font:600 12px/1.5 ' + FONT + ';color:#cdd7f0;overflow-wrap:anywhere}' +
  '.dh-job-card ul{margin:0;padding:0;list-style:none;display:flex;flex-direction:column;gap:3px}' +
  '.dh-job-card li{font:800 12px/1.35 ' + FONT + ';color:#ffe9b8;overflow-wrap:anywhere}' +
  '.dh-job-card li i{font-style:normal;color:var(--bc);margin-right:4px}' +
  '.dh-job-card .dh-r-btn{width:100%;min-width:0;padding:6px 8px;font-size:15px;white-space:normal;line-height:1.25}' +
  '.dh-job-tabs{flex:0 0 auto;display:flex;gap:6px;padding:8px 10px 0}' +
  '.dh-job-tab{position:relative;flex:1 1 0;min-width:0;min-height:44px;border-radius:9px;border:1.5px solid rgba(174,185,218,.45);background:rgba(14,20,40,.9);color:#cfd8f5;font:900 15px ' + FONT + ';cursor:pointer}' +
  '.dh-job-tab[aria-selected="true"]{border-color:#f2c14e;background:rgba(242,193,78,.16);color:#ffe7a0}' +
  '.dh-job-tab .dot{position:absolute;top:5px;right:7px;width:9px;height:9px;border-radius:50%;background:#f2c14e;box-shadow:0 0 8px #f2c14e}' +
  '.dh-job-warn{font:800 12px/1.45 ' + FONT + ';color:#ffb0a8}' +
  // 낮은 가로 화면(폰 가로 390px 안팎, 세로로 든 폰의 회전 화면 포함): 컨테이너 높이로 판단한다(회전된 게임 화면에서는 미디어 쿼리가 틀린다)
  '@container dh-skill-view (max-height:460px){.dh-job{gap:6px;padding:6px 10px 10px}.dh-job-say{padding:6px 10px;font-size:12px}.dh-job-say b{display:none}' +
  '.dh-job-tabs{padding-top:6px}.dh-job-tab{min-height:40px;font-size:14px}.dh-job-step{font-size:13px}' +
  '.dh-job-gate{padding:6px 9px}.dh-job-gate .ht{font-size:11px}.dh-job-card{padding:8px;gap:4px}.dh-job-card h4{font-size:15px}' +
  '.dh-job-card p{font-size:11px;line-height:1.4;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden}.dh-job-card li{font-size:11px}' +
  '.dh-job-card .dh-r-btn{min-height:44px}.dh-job-warn{font-size:11px}}' +
  '.dh-job-done{padding:12px;border-radius:12px;border:2px solid var(--bc);background:linear-gradient(180deg,color-mix(in srgb,var(--bc) 24%,#0c1226),#0a0f20);display:flex;flex-direction:column;gap:6px}' +
  '.dh-job-done h4{margin:0;font:900 20px ' + FONT + ';color:#fff;text-shadow:0 0 12px var(--bc)}';

export class JobPanel {
  /** 다시 그려야 할 때 오른다(RpgUi 재그리기 키) */
  version = 0;
  /** 확인 단계에 들어간 갈래(-1 없음) */
  private confirm = -1;

  /** 교관 창을 새로 열 때 확인 단계를 지운다 */
  open(): void { if (this.confirm !== -1) { this.confirm = -1; this.version++; } }

  render(parent: HTMLElement, view: GameView, send: (c: GameCommand) => void, locked: boolean): void {
    ensureStyle();
    const job = view.job;
    const root = el('div', '', parent); root.className = 'dh-job'; root.dataset.testid = 'job-panel';
    if (!job || !job.available) { el('p', 'color:#bdcce0;font-size:13px;', root, '이 영웅의 전직은 아직 준비 중이에요.'); return; }
    const level = growthOf(view)?.level ?? view.hero.level;
    const m = jobPanelModel(job, level);
    const hero = job.hero ?? 'kael', brs = JOB_BRANCHES[hero];
    const say = el('div', '', root); say.className = 'dh-job-say'; say.dataset.testid = 'job-say';
    el('b', '', say, JOB_TRAINER_TITLE[hero]);
    el('span', '', say, '“' + m.say + '”');

    if (m.phase === 'done' && m.branch) {
      const bc = m.branch;
      const box = el('div', '', root); box.className = 'dh-job-done'; box.dataset.testid = 'job-done'; box.style.setProperty('--bc', bc.color);
      el('small', 'font:900 12px ' + FONT + ';color:#7dffa0;', box, '전직 완료 · 전직 II');
      el('h4', '', box, bc.name);
      el('p', 'margin:0;font:600 12px/1.5 ' + FONT + ';color:#cdd7f0;', box, bc.motto);
      el('p', 'margin:0;font:800 13px/1.5 ' + FONT + ';color:#ffe9b8;', box, '습득: ' + bc.skills[0] + ' · ' + bc.skills[1]);
    } else {
      const step = el('div', '', root); step.className = 'dh-job-step';
      const roman = m.gateTier === 1 ? 'I' : 'II';
      const title = m.phase === 'pick' ? '전직 I · 갈래 선택' : m.phase === 'advance' ? '전직 II · 승급' : '전직 ' + roman + ' 관문';
      el('span', '', step, title);
      el('small', '', step, '필요 Lv' + m.needLevel + ' · 지금 Lv' + level);
      if (m.branch) el('small', 'flex-basis:100%;color:' + m.branch.color + ';', step, '현재 갈래 · ' + m.branch.name);
      if (m.phase === 'gates1' || m.phase === 'gates2' || m.phase === 'advance') {
        m.gates.forEach((g, i) => this.drawGate(root, g, i, send));
      }
      if (m.phase === 'pick') this.drawPick(root, m.levelOk, locked, send, brs);
      if (m.phase === 'advance') {
        const b = this.btn(root, '전직 II 승급', () => send({ type: 'jobAdvance' }), true);
        b.dataset.testid = 'job-advance'; b.disabled = locked || !m.levelOk; b.style.width = '100%';
        if (!m.levelOk) el('div', '', root, 'Lv' + JOB_LEVEL[2] + ' 필요').className = 'dh-job-warn';
      }
    }
  }

  /** 교관 창 위쪽 「스킬 / 전직」 탭. 지금 할 수 있는 전직 일(열린 관문·갈래 선택·승급)이 있으면 전직 탭에 금색 점 */
  renderTabs(parent: HTMLElement, view: GameView, current: 'skills' | 'job', pick: (t: 'skills' | 'job') => void): void {
    const job = view.job;
    const todo = !!job && job.tier < 2 && (job.ready > 0 || job.open.some((id) => !job.passed.includes(id)));
    const row = el('div', '', parent); row.className = 'dh-job-tabs'; row.setAttribute('role', 'tablist');
    (['skills', 'job'] as const).forEach((t) => {
      const b = el('button', '', row, t === 'skills' ? '스킬' : '전직');
      b.type = 'button'; b.className = 'dh-job-tab'; b.dataset.testid = 'trainer-tab-' + t;
      b.setAttribute('role', 'tab'); b.setAttribute('aria-selected', String(current === t));
      if (t === 'job' && todo) el('i', '', b).className = 'dot';
      b.addEventListener('click', () => pick(t));
    });
  }

  private btn(parent: HTMLElement, label: string, run: () => void, primary = false): HTMLButtonElement {
    const b = el('button', '', parent, label);
    b.type = 'button'; b.className = 'dh-r-btn' + (primary ? ' pri' : ''); b.dataset.sfx = primary ? 'event' : '';
    b.addEventListener('click', run);
    return b;
  }

  private drawGate(parent: HTMLElement, g: JobGateRow, i: number, send: (c: GameCommand) => void): void {
    const row = el('div', '', parent); row.className = 'dh-job-gate ' + g.state; row.dataset.testid = 'job-gate-' + (i + 1); row.dataset.state = g.state;
    el('div', '', row, g.name).className = 'nm';
    el('div', '', row, g.hint).className = 'ht';
    if (g.state === 'open') {
      const b = this.btn(row, '도전', () => { send({ type: 'closeMenu' }); send({ type: 'enterTrial', trial: g.id }); }, true);
      b.dataset.testid = 'job-gate-go-' + (i + 1); b.style.gridColumn = '2/3'; b.style.gridRow = '1/3';
    } else {
      const s = el('div', '', row, g.state === 'passed' ? '통과 ✓' : '🔒 ' + g.lock);
      s.className = 'st ' + (g.state === 'passed' ? 'ok' : 'lock');
    }
  }

  private drawPick(parent: HTMLElement, levelOk: boolean, locked: boolean, send: (c: GameCommand) => void, brs: (typeof JOB_BRANCHES)[JobHeroId]): void {
    const cards = el('div', '', parent); cards.className = 'dh-job-cards'; cards.dataset.testid = 'job-cards';
    brs.forEach((b, i) => {
      const c = el('div', '', cards); c.className = 'dh-job-card' + (this.confirm >= 0 && this.confirm !== i ? ' dim' : '');
      c.style.setProperty('--bc', b.color); c.dataset.testid = 'job-card-' + i;
      el('h4', '', c, b.name);
      el('p', '', c, b.motto);
      const ul = el('ul', '', c);
      b.skills.forEach((s, k) => { const li = el('li', '', ul, (k === 0 ? '전직 I · ' : '전직 II · ') + s); li.prepend(el('i', '', undefined, '◆')); });
      if (this.confirm === i) {
        el('div', '', c, '정하면 되돌릴 수 없어요. 정말 ' + b.name + '(으)로 전직할까요?').className = 'dh-job-warn';
        const yes = this.btn(c, '네, 전직합니다', () => { this.confirm = -1; this.version++; send({ type: 'jobChoose', branch: i }); }, true);
        yes.dataset.testid = 'job-confirm-yes'; yes.disabled = locked;
        // 낮은 화면에서 확인 버튼이 스크롤 아래에 가려지지 않게 그린 직후 보이는 곳으로 올린다
        requestAnimationFrame(() => yes.scrollIntoView({ block: 'nearest' }));
        const no = this.btn(c, '취소', () => { this.confirm = -1; this.version++; });
        no.dataset.testid = 'job-confirm-no';
      } else {
        const go = this.btn(c, '이 갈래로 전직', () => { this.confirm = i; this.version++; }, true);
        go.dataset.testid = 'job-pick-' + i; go.disabled = locked || !levelOk || this.confirm >= 0;
      }
    });
    if (!levelOk) el('div', '', parent, 'Lv' + JOB_LEVEL[1] + ' 필요').className = 'dh-job-warn';
  }
}

function ensureStyle(): void {
  if (document.getElementById(STYLE_ID)) return;
  const s = document.createElement('style'); s.id = STYLE_ID; s.textContent = CSS; document.head.appendChild(s);
}
